import React from 'react';
import './styles.scss';

import SpinnerComponent from "../../reusable/SpinnerComponent/SpinnerComponent";


const AuthSpinnerComponent = () => {
  return (
    <div className='spinner-inner-wrapper'>
      <SpinnerComponent/>
    </div>
  )
};

export default AuthSpinnerComponent